import {
  CreateUserPost,
  Permission,
  User,
  UserData,
  UserFilters,
} from '@dispatch/shared/types';
import { dispatchClient } from '../clients';
import axios, { AxiosError } from 'axios';
import { mapResponseWithPaging } from '../helpers/AxiosMappers';

const AUTHORIZATION_USERS_URL = `dispatch/auth/users`;
const AUTHORIZATION_USERS_Permissions_URL = (userId: string) =>
  `dispatch/auth/users/${userId}/permissions`;

export async function getUsers(
  filters?: UserFilters,
  continuationToken?: string
) {
  const response = await dispatchClient.get<User[]>(
    `${AUTHORIZATION_USERS_URL}`,
    {
      params: {
        ...filters,
      },
      headers: {
        'Continuation-Token': continuationToken || '',
      },
    }
  );

  return mapResponseWithPaging(response);
}

export async function getUser(userId: string) {
  return dispatchClient.get<UserData>(`${AUTHORIZATION_USERS_URL}/${userId}`);
}

export async function getUserPermissions(userId: string) {
  return dispatchClient.get<Permission[]>(
    AUTHORIZATION_USERS_Permissions_URL(userId)
  );
}

export async function upsertUser(postData: Partial<CreateUserPost>) {
  try {
    await dispatchClient.put<User>(`${AUTHORIZATION_USERS_URL}`, postData);
    return { success: true };
  } catch (e) {
    return handleError(e as AxiosError | Error, 'Failed to create user');
  }
}

const handleError = (error: AxiosError | Error, defaultMessage: string) => {
  if (axios.isAxiosError(error)) {
    return {
      success: false,
      message:
        error.response?.status === 400 ? error.response?.data : defaultMessage,
    };
  }

  return { success: false, message: error?.message || defaultMessage };
};
